export default __webpack_public_path__ + "static/media/nessie-sketch.387c700f.webp";